import functions from './functions'
import * as expressions from './expressions'

export default {
  functions, // Use to modify strings
  expressions // Exports raw regular expressions
}
